__turbopack_context__.v({
  "disabledLabel": "ToggleSwitch-module__DiTyPa__disabledLabel",
  "labelText": "ToggleSwitch-module__DiTyPa__labelText",
  "large": "ToggleSwitch-module__DiTyPa__large",
  "offLabel": "ToggleSwitch-module__DiTyPa__offLabel",
  "onLabel": "ToggleSwitch-module__DiTyPa__onLabel",
  "small": "ToggleSwitch-module__DiTyPa__small",
  "toggle": "ToggleSwitch-module__DiTyPa__toggle",
  "toggleIndicator": "ToggleSwitch-module__DiTyPa__toggleIndicator",
  "toggleInput": "ToggleSwitch-module__DiTyPa__toggleInput",
  "toggleTrack": "ToggleSwitch-module__DiTyPa__toggleTrack",
  "toggleTrackNoLabel": "ToggleSwitch-module__DiTyPa__toggleTrackNoLabel",
  "toggleTrackWithLabel": "ToggleSwitch-module__DiTyPa__toggleTrackWithLabel",
});
